"use strict";import{IconDeleteOutline as e}from"../src/elements/IconDeleteOutline.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-icon-delete-outline",e);
//# sourceMappingURL=sp-icon-delete-outline.js.map
